import {Response} from '..'

// suggestion from docs:
// https://github.com/Microsoft/TypeScript/wiki/FAQ#why-doesnt-extending-built-ins-like-error-array-and-map-work
export class RequestError<T extends Response = Response> extends Error {
  public statusCode: number
  public response: T

  public constructor(
    resp: T,
    message = `Unsuccessful request status code: ${resp.statusCode}`
  ) {
    super(message)
    this.response = resp
    this.statusCode = resp.statusCode

    Object.setPrototypeOf(this, RequestError.prototype)
    // Maintains proper stack trace for where our error was throw (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, RequestError)
    }
    this.name = this.constructor.name
  }
}
